import * as yup from "yup";

export const updateAlignerMaterialSchema = yup.object().shape({
  caseId: yup.string().required("Case Id is required"),
  alignerMaterialId: yup.string().required("Aligner Material Id is required"),
});
